import {
  collection,
  getDocs,
  query,
  limit,
  startAfter,
  QueryDocumentSnapshot,
  DocumentData,
  orderBy,
  getCountFromServer,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Domain from '../../models/Domain';

async function getDomains(
  offset: number,
  lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData>
): Promise<{
  domains: Domain[];
  lastVisible: QueryDocumentSnapshot<DocumentData, DocumentData>;
  totalCollectionCount: number;
}> {
  try {
    const db = firestore;
    const domainsCollection = collection(db, FirestoreCollections.domains);

    const results = lastVisible
      ? await getDocs(
          query(
            domainsCollection,
            orderBy('created'),
            startAfter(lastVisible),
            limit(offset)
          )
        )
      : await getDocs(
          query(domainsCollection, orderBy('created'), limit(offset))
        );

    const domains: Domain[] = [];

    results.docs.forEach((doc) => {
      domains.push(Domain.fromFirestore(doc));
    });

    const domainsSnapshotAll = await getCountFromServer(
      query(domainsCollection)
    );

    return {
      domains,
      lastVisible: results.docs[results.docs.length - 1],
      totalCollectionCount: domainsSnapshotAll.data().count ?? 0,
    };
  } catch (e) {
    console.log('error: ', e);
    throw new GetDomainsFailure();
  }
}

export class GetDomainsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getDomains;
